import { Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ReactElement } from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from 'react-router-dom';

type Props = {
    data: ({
        url: string;
        tileTitle: ReactElement;
        tileIcon: ReactElement;
        tileText: ReactElement;
        sortOrder: number;
    } | null)[];
};

const sxStyles = {
    copies: {
        marginLeft: 3,
        marginRight: 2,
    },
    title: {
        fontWeight: 500,
        color: '#1F3045',
    },
    disabled: {
        color: '#8D8D8D',
        cursor: 'default',

        '& .MuiSvgIcon-root': {
            color: '#8D8D8D',
        },
        '&:hover': {
            backgroundColor: '#fff',
        },
    },
    description: {
        fontWeight: 400,
        fontSize: '14px',
        color: '#5A6B81',
    },
    paper: {
        paddingLeft: 3,
        paddingRight: 3,
        paddingBottom: 2,
        paddingTop: 2,
        marginBottom: '20px',
        backgroundColor: '#fff',
        display: 'block',
        textDecoration: 'none',
        borderRadius: '4px',

        '&:hover': {
            backgroundColor: '#BFCEE3',
        },
    },
    arrowIcon: {
        marginLeft: 'auto',
        fontSize: '40px',
        color: '#1F3045',
    },
};

const ServiceList = ({ data }: Props) => (
    <>
        {data.map((value, index) => {
            const userHasAccess = value?.url !== '#';

            return (
                <Box
                    component={Link}
                    to={userHasAccess && value?.url ? value.url : '#'}
                    sx={[sxStyles.paper, !userHasAccess && sxStyles.disabled]}
                    key={index}
                >
                    <Stack direction="row" alignItems="center">
                        {value?.tileIcon}

                        <Box sx={sxStyles.copies}>
                            <Typography variant="body1" sx={[sxStyles.title, !userHasAccess && sxStyles.disabled]}>
                                {value?.tileTitle}
                            </Typography>

                            <Typography sx={[sxStyles.description, !userHasAccess && sxStyles.disabled]}>
                                {value?.tileText}
                            </Typography>
                        </Box>

                        <ArrowForwardIcon sx={[sxStyles.arrowIcon, !userHasAccess && sxStyles.disabled]} />
                    </Stack>
                </Box>
            );
        })}
    </>
);

export default ServiceList;
